/**
 * Small global disclaimer shown on every page.
 * Reminds users the app is for educational purposes only and not financial advice.
 */
export function EducationalDisclaimer() {
  return (
    <div className="w-full border-t border-border/50 bg-background/80 backdrop-blur-sm py-2 px-4 text-center">
      <p className="text-[10px] leading-relaxed text-muted-foreground/80 max-w-3xl mx-auto">
        For educational and informational purposes only. Not financial advice. Trading involves substantial risk of loss.
      </p>
    </div>
  );
}
